import { useFiltersContext } from '@/features/world-map/context/filters';
import { useMemo } from 'react';
import classes from './filter-button.module.css';

/**
 * @param {React.HTMLProps<HTMLButtonElement>} props
 * @returns {React.JSX.Element}
 */
export function FilterButton({ className, ...props }) {
  const { filters } = useFiltersContext();

  const filterCount = useMemo(() => {
    const nonEmptyFilters = Object.values(filters).filter((value) => value.length > 0);
    return nonEmptyFilters.length;
  }, [filters]);

  return (
    <button {...props} type="button" className={`btn ${classes.btn} ${className ?? ''}`} aria-label="Edit filters">
      <svg width="15" height="15" viewBox="0 0 15 15">
        <path
          d="M6.75556 14.6999V9.93324H8.34445V11.5221H14.7V13.111H8.34445V14.6999H6.75556ZM0.400002
          13.111V11.5221H5.16667V13.111H0.400002ZM3.57778
          9.93324V8.34435H0.400002V6.75546H3.57778V5.16657H5.16667V9.93324H3.57778ZM6.75556
          8.34435V6.75546H14.7V8.34435H6.75556ZM9.93334
          5.16657V0.399902H11.5222V1.98879H14.7V3.57768H11.5222V5.16657H9.93334ZM0.400002
          3.57768V1.98879H8.34445V3.57768H0.400002Z"
        />
      </svg>
      Filter
      {filterCount > 0 && (
        <span className={classes.badge} aria-label={`${filterCount} filter${filterCount === 1 ? '' : 's'} active`}>
          {filterCount}
        </span>
      )}
    </button>
  );
}
